import {
  currencyCodeColumnDefinition,
  enabledFlagColumnDefinition,
  precisionColumnDefinition,
} from '../../../shared/columnDefinitions';

export default [
  enabledFlagColumnDefinition,
  currencyCodeColumnDefinition,
  precisionColumnDefinition,
];
